export default __webpack_public_path__ + "static/lina-5f9c2cf1c7ea497c55b9a94e5e27557d.jpg";